import { TypographyProps } from '@mui/material/Typography';

import { TextWeightType } from './types';

const WEIGHT_MAPPINGS: Record<TextWeightType, TypographyProps['fontWeight']> = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

const VARIANTS: TypographyProps['variant'][] = [
  'displayXxl',
  'displayXl',
  'displayLg',
  'displayMd',
  'displaySm',
  'displayXs',
  'textXl',
  'textLg',
  'textMd',
  'textSm',
  'textXs',
];

const CONFIG = {
  WEIGHT_MAPPINGS,
  VARIANTS,
} as const;

export default CONFIG;
